import { createFeatureActionNamer } from '../redux/action-name';
const getActionName = createFeatureActionNamer('initiate-claim');

export const SEARCH_RESULTS_LOADED = getActionName('SEARCH_RESULTS_LOADED');
export const SET_SEARCH_CRITERIA = getActionName('SET_SEARCH_CRITERIA');
export const CONTRACTS_LOADED = getActionName('CONTRACTS_LOADED');
export const SET_SELECTED_CLIENTS = getActionName('SET_SELECTED_CLIENTS');
